var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15803_12491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33047 0.376563L8.99922 0.0859375L8.66797 0.376563L0.167969 7.87656L0.830469 8.62656L1.99922 7.59531V15.5016V16.0016H2.49922H15.4992H15.9992V15.5016V7.59531L17.168 8.62656L17.8305 7.87656L9.33047 0.376563ZM2.99922 15.0016V6.71094L8.99922 1.41719L14.9992 6.71094V15.0016H11.4992V9.50156V9.00156H10.9992H6.99922H6.49922V9.50156V15.0016H2.99922ZM7.49922 15.0016V10.0016H10.4992V15.0016H7.49922Z",
    fill: "#1D1F2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15803_12491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.95752cee04eee5c7be6cbd979fce7cf8.svg";
export { ForwardRef as ReactComponent };